import { useCallback, useState } from 'react';
import { Client, ClientsFilter } from '@entities/clients';
import { gql, useQuery } from 'urql';

const GET_SMINEX_CLUB_CLIENTS_FOR_EVENT_QUERY = gql`
  query GetSminexClubClientsForEvent(
    $eventId: Int!
    $orderBy: [SminexClubClientsOrderBy!]
    $searchString: String
    $clientsFilter: SminexClubEventFilter
  ) {
    getSminexClubClientsForEvent(
      eventId: $eventId
      orderBy: $orderBy
      searchString: $searchString
      clientsFilter: $clientsFilter
    ) {
      total
      invitationAccepted
      invitationDeclined
      checked
      sminexClubClients {
        id
        participantId
        firstName
        lastName
        surname
        age
        photoUrl
        phone
        maritalStatus
        countChildren
        brokerName
        doNotCall
        notes
        ticket {
          id
          checked
          invitationStatus
          sminexClubInvitation
          review
          sminexClubAdditional
          organizerName
          comment
        }
        manager {
          id
          firstName
          lastName
          surname
        }
        events {
          eventId
          eventName
          checked
        }
        projects {
          amount
          project {
            id
            name
            type
            active
          }
        }
      }
    }
  }
`;

interface SminexClubClientsForEventResponse {
  getSminexClubClientsForEvent: {
    total: number;
    invitationAccepted: number;
    invitationDeclined: number;
    checked: number;
    sminexClubClients: Client[];
  };
}

export const useFetchSminexClubClientsForEvent = (eventId: number) => {
  const [searchString, setSearchString] = useState<string>('');
  const [orderBy, setOrderBy] = useState<string[] | null>(null);
  const [clientsFilter, setClientsFilter] = useState<ClientsFilter>({});

  const [{ data, fetching, error }, executeQuery] = useQuery<SminexClubClientsForEventResponse>({
    query: GET_SMINEX_CLUB_CLIENTS_FOR_EVENT_QUERY,
    variables: {
      eventId,
      searchString,
      orderBy,
      clientsFilter,
    },
    requestPolicy: 'network-only',
  });

  const handleSearchChange = (value: string) => {
    setSearchString(value);
  };

  const handleOrderChange = (value: string[] | null) => {
    setOrderBy(value);
  };

  const handleFilterChange = (value: ClientsFilter) => {
    setClientsFilter(value);
  };

  const response = data?.getSminexClubClientsForEvent;

  const clients = response?.sminexClubClients;

  const ticketInfo = {
    total: response?.total || 0,
    countAccepted: response?.invitationAccepted || 0,
    countDeclined: response?.invitationDeclined || 0,
    checked: response?.checked || 0,
  };

  const refetch = useCallback(() => {
    executeQuery({ requestPolicy: 'network-only' });
  }, [executeQuery]);

  return { clients, fetching, error, handleSearchChange, handleOrderChange, handleFilterChange, ticketInfo, refetch };
};
